import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1801.44118,0 L1801.44118,1920 L219.029412,1920 L219.029412,1480.78431 L162.514706,1480.78431 C131.318588,1480.78431 106,1455.48549 106,1424.31373 C106,1393.14196 131.318588,1367.84314 162.514706,1367.84314 L162.514706,1367.84314 L219.029412,1367.84314 L219.029412,1029.01961 L162.514706,1029.01961 C131.318588,1029.01961 106,1003.72078 106,972.54902 C106,941.377255 131.318588,916.078431 162.514706,916.078431 L162.514706,916.078431 L219.029412,916.078431 L219.029412,577.254902 L162.514706,577.254902 C131.318588,577.254902 106,551.956078 106,520.784314 C106,489.612549 131.318588,464.313725 162.514706,464.313725 L162.514706,464.313725 L219.029412,464.313725 L219.029412,0 L1801.44118,0 Z M1688.41176,112.941176 L332.058824,112.941176 L332.058824,464.313725 L388.573529,464.313725 C419.769647,464.313725 445.088235,489.612549 445.088235,520.784314 C445.088235,551.956078 419.769647,577.254902 388.573529,577.254902 L388.573529,577.254902 L332.058824,577.254902 L332.058824,916.078431 L388.573529,916.078431 C419.769647,916.078431 445.088235,941.377255 445.088235,972.54902 C445.088235,1003.72078 419.769647,1029.01961 388.573529,1029.01961 L388.573529,1029.01961 L332.058824,1029.01961 L332.058824,1367.84314 L388.573529,1367.84314 C419.769647,1367.84314 445.088235,1393.14196 445.088235,1424.31373 C445.088235,1455.48549 419.769647,1480.78431 388.573529,1480.78431 L388.573529,1480.78431 L332.058824,1480.78431 L332.058824,1807.05882 L1688.41176,1807.05882 L1688.41176,112.941176 Z M640.287953,425.201841 L1388.89922,425.201841 L1388.89922,538.141843 L640.287953,538.141843 L640.287953,425.201841 Z M640.287953,640.031283 L1279.72674,640.031283 L1279.72674,752.971285 L640.287953,752.971285 L640.287953,640.031283 Z M640.287953,1174.87637 L1388.89922,1174.87637 L1388.89922,1287.81637 L640.287953,1287.81637 L640.287953,1174.87637 Z M640.287953,1389.70581 L1279.72674,1389.70581 L1279.72674,1502.64581 L640.287953,1502.64581 L640.287953,1389.70581 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconSyllabusLine = /*#__PURE__*/function (_Component) {
  _inherits(IconSyllabusLine, _Component);

  var _super = _createSuper(IconSyllabusLine);

  function IconSyllabusLine() {
    _classCallCheck(this, IconSyllabusLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconSyllabusLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconSyllabus",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconSyllabusLine.displayName = "IconSyllabusLine";
  return IconSyllabusLine;
}(Component);

IconSyllabusLine.glyphName = 'syllabus';
IconSyllabusLine.variant = 'Line';
IconSyllabusLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconSyllabusLine;
export { IconSyllabusLine };